/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum JobType {
    BatchMove = 'BATCH_MOVE',
    BatchMoveValidate = 'BATCH_MOVE_VALIDATE',
    ExportDevices = 'EXPORT_DEVICES',
    ExportProvisioningDevices = 'EXPORT_PROVISIONING_DEVICES',
    BatchAutoFill = 'BATCH_AUTO_FILL'
}

export function JobTypeFromJSON(json: any): JobType {
    return JobTypeFromJSONTyped(json, false);
}

export function JobTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): JobType {
    return json as JobType;
}

export function JobTypeToJSON(value?: JobType | null): any {
    return value as any;
}

